import { getCurrentWeek } from "./legacyUtils";

const convertTimeToDate = (time: string, isStart?: boolean) => {
    const hours = parseInt(time.slice(0, 2));
    const minutes = parseInt(time.slice(3));

    return new Date(0, 0, 0, hours, isStart ? minutes + 55 : minutes);
};

interface Periodic {
    end: string;
    start: string;
}

export const checkIfInPeriod = (
    periodArray: Periodic[] | undefined,
    time: string
) => {
    if (!periodArray) {
        return false;
    }
    return periodArray.some(
        (period) =>
            convertTimeToDate(period.end) > convertTimeToDate(time) &&
            convertTimeToDate(period.start) <= convertTimeToDate(time, true)
    );
};

export const convertTimeToString = (time: Date) =>
    `${convertToTwoDigit(time.getHours())}:${convertToTwoDigit(
        time.getMinutes()
    )}`;

export const addMinutes = (date: Date, minutes: number) =>
    new Date(date.getTime() + minutes * 60000);

const convertToTwoDigit = (time: number) =>
    time < 10 ? `0${time}` : time.toString();

export const getWeekYear = (week: number) => {
    const currentWeek = getCurrentWeek();
    const currentYear = new Date().getFullYear();

    return week < currentWeek ? currentYear + 1 : currentYear;
};
